import { useContext } from "react";
import KyoceraLogo from "../../assets/images/kyocera-logo.png";
import DevPortalLogo from "../../assets/images/dev_portal_logo.png";
import { useTranslation } from "react-i18next";
import { BRAND_NAMES } from "../../utils/constants";
import { AppConfig } from "../../context/context";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import NavItemComponent from "./nav-item/nav-item";

import { styled } from "@mui/system";
import { Extension, SupervisorAccount } from "@mui/icons-material";

const SideNavComponent = () => {
  const theme = useTheme();
  const context = useContext(AppConfig);
if (!context || !context.config || !context.userProfile) {
  throw new Error("AppConfig context is not properly initialized.");
}
const { config, userProfile } = context;

  const SideNav = styled("div")({
    backgroundColor: "var(--kyocera-cp-background-grey) !important",
    borderRadius: "0px 10px 10px 0px",
    gridTemplateRows: "160px 65px auto",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(1.5),
    ".title": {
      gridRowStart: 1,
      gridRowEnd: 2,
      paddingTop: theme.spacing(2),

      "& .login-image": {
        width: "160px",
        padding: theme.spacing(2),
      },

      "& .login-image-text": {
        width: "200px",
        padding: theme.spacing(1),
      },

      "& h1": {
        fontSize: "1.8rem",
      },
    },
    ".menu": {
      gridRowStart: 2,
      gridRowEnd: 3,
      padding: theme.spacing(2),
    },
    ".menuItems": {
      gridRowStart: 2,
      gridRowEnd: 3,
      padding: theme.spacing(2),
    },
  });

  const { t } = useTranslation("common");

  return (
  
  <SideNav>
      <Box
        className="title"
        display="flex"
        justifyContent="start"
        flexDirection="column"
        alignItems="center"
      >
        <img
          className="login-image-text d-block"
          alt="Provider portal"
          src={DevPortalLogo}
        />
      </Box>
      <div className="menuItems">
        <NavItemComponent
          exact={true}
          to="/"
          title={t("page_application_title")}
        >
          <Extension fontSize="small" />
        </NavItemComponent>
        
          <NavItemComponent
            exact={true}
            to="/users"
            title={t("Users")}
            > 
              <SupervisorAccount fontSize="small" />
            </NavItemComponent>
      </div>
      <Box
        className="title"
        display="flex"
        flexDirection="column"
        height="100%"
        flexWrap="wrap"
        justifyContent="flex-end"
        alignContent="center"
      >
        {config.configBrand === BRAND_NAMES.KYOCERA && (
          <img
            className="login-image d-block"
            alt="Kyocera"
            src={KyoceraLogo}
          />
        )}
        {config.configBrand === BRAND_NAMES.TA && (
          <div className="login-image d-block" style={{ height: "45px" }}></div>
        )}
      </Box>
  </SideNav>
  );
};

export default SideNavComponent;
